import React, { useMemo } from 'react';
import {
  Label, Popup,
} from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';

export const TagContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: ${({ noMargin }) => (!noMargin ? '5px' : '0px')};;
  border-radius: 5px;
  &&&>* {
    margin: ${({ noMargin }) => (!noMargin ? '5px' : '0px')};
  }
`;

const SimpleTag = ({
  // eslint-disable-next-line no-unused-vars
  staticContext, tag, history, onRemove, showCount, onClick, showDataEditor, noRedirect, ...props
}) => {

  const LabelComponent = useMemo(() => (tag ? (
    <Label
      key={tag._id}
      size={showDataEditor ? 'tiny' : 'medium'}
      pointing='left'
      as={!onClick && noRedirect ? null : 'a'}
      onClick={() => {
        if (onClick) {
          onClick(tag);
        }
        if (!noRedirect) {
          history.push(`/tags/${tag._id}`);
        }
      }}
      onRemove={onRemove ? (e) => {
        e.preventDefault();
        e.stopPropagation();
        onRemove(tag);
      } : null}
      content={showCount && 'totalCount' in tag ? `${tag.value} (${tag.totalCount})` : (tag.value + (tag.type === 'financial' ? ` in ${tag?.typeData?.financialValue === 'percentage' ? '%' : '£'}` : ''))}
      style={showDataEditor ? { height: 29, fontSize: '0.8em', marginLeft: 0 } : { marginLeft: 0 }}
      {...props}
    />
  ) : null), [tag, history, onRemove, showCount, onClick, noRedirect, props, showDataEditor]);
  return LabelComponent;
};

export const Tag = ({
  tag, noPopup, ...props
}) => {
  const sharedProps = { tag};

  if (!tag.description || noPopup) {
    return <SimpleTag {...sharedProps} {...props} />;
  }
  return (
    <Popup
      trigger={<SimpleTag {...sharedProps} {...props} />}
      on="hover"
    >
      <Popup.Content>
        <h5>About this tag</h5>
        {tag.description}
      </Popup.Content>
    </Popup>
  );
};

export default withRouter(Tag);
